import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';
import React from 'react';
import { TEST_IDS } from '../../../constants';

export const Modifier = ({ name, date, id }: { name: string; date: string; id: string }) => {
    return (
        <Box data-testid={TEST_IDS.TEMPLATE_MODIFIER(id)} sx={{ minWidth: 300 }}>
            <Typography variant="body-md">{name}</Typography>
            <Typography variant="body-md">{date}</Typography>
        </Box>
    );
};
